module.exports = __webpack_public_path__ + "img/loading.5fc1f217.gif";